/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { UpdateOneTimeUserDto } from '../models/UpdateOneTimeUserDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class OneTimeAuthService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns any
     * @throws ApiError
     */
    public isTokenValid(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/one-time-auth/is-token-valid',
        });
    }

    /**
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    public updateInfo(
        requestBody: UpdateOneTimeUserDto,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/one-time-auth/update-info',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Generate jwt for one-time-user by personal number
     * @param pnr
     * @returns string
     * @throws ApiError
     */
    public generateTestOneTimeUserJwtByPnr(
        pnr: string,
    ): CancelablePromise<string> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/one-time-auth/generate-test-one-time-user-jwt-by-pnr/{pnr}',
            path: {
                'pnr': pnr,
            },
        });
    }

}
